module.exports = __webpack_public_path__ + "img/banner-6.9d4ecebd.png";